import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export const notify = (errorResponse: string, success = false) => {
    toast.dismiss();
    if (success) {
        toast.success(errorResponse, {
            position: toast.POSITION.BOTTOM_CENTER,
        });
    } else {
        toast.error(errorResponse, {
            position: toast.POSITION.BOTTOM_CENTER,
        });
    }
};
